import React from 'react'
import { useTranslation } from 'react-i18next'

import FooterDocument from 'utils/__enums/Footer/FooterDocument'
import logo from 'assets/logo_footer.png'
import ROUTES from 'utils/ROUTES'

const Footer: React.FC = () => {
  const { t } = useTranslation()

  const url = `${process.env.REACT_APP_FOOTER_URL_PDF}resources/`

  return (
    <footer className="footer">
      <div className="footer__container container">
        <div className="footer__links row">
          <div className="col-sm-6">
            <div className="my-2">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`${url}${FooterDocument.CGU}`}
              >
                {t('footer.links.cgu')}
              </a>
            </div>
            <div className="my-2">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`${url}${FooterDocument.CGV}`}
              >
                {t('footer.links.cgv')}
              </a>
            </div>
            <div className="my-2">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`${url}${FooterDocument.COOKIES_CHARTE}`}
              >
                {t('footer.links.cookies')}
              </a>
            </div>
            <div className="my-2">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`${url}${FooterDocument.LEGAL_NOTICES}`}
              >
                {t('footer.links.legal')}
              </a>
            </div>
            <div className="my-2">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={ROUTES.PrivatePolicy}
              >
                {t('footer.links.confidentiality')}
              </a>
            </div>
          </div>
          <div className="col-sm-6 d-flex justify-content-center align-items-center">
            <div className="footer__left mt-4">
              <img src={logo} alt="suez logo" className="logo" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
